// Real-time presence: sends an anonymous heartbeat to the backend every 15s
// so the admin can see how many users are currently on the site and on each
// section (Home / Produto / Checkout / Pós-compra). Stores nothing on disk —
// the backend keeps only an in-memory dict that auto-expires after 45s.

import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const HEARTBEAT_MS = 15000;
const STORAGE_KEY = "velnix_presence_sid";

function getSessionId() {
  try {
    let sid = sessionStorage.getItem(STORAGE_KEY);
    if (!sid) {
      sid = (crypto?.randomUUID && crypto.randomUUID()) || `s-${Math.random().toString(36).slice(2)}-${Date.now()}`;
      sessionStorage.setItem(STORAGE_KEY, sid);
    }
    return sid;
  } catch {
    return `s-${Math.random().toString(36).slice(2)}-${Date.now()}`;
  }
}

let intervalId = null;

function sendHeartbeat() {
  const page = window.location?.pathname || "/";
  // Skip presence reporting from the admin panel itself — it would mess with the count.
  if (page.startsWith("/admin")) return;
  axios.post(`${API}/presence/heartbeat`, {
    session_id: getSessionId(),
    page,
  }).catch(() => { /* silent: presence is best-effort */ });
}

export function startPresence() {
  if (intervalId) return;
  // Fire one immediately so the count is reactive
  sendHeartbeat();
  intervalId = setInterval(sendHeartbeat, HEARTBEAT_MS);
  // Re-trigger on visibility change so a user coming back to the tab shows up immediately
  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) sendHeartbeat();
  });
}

export function stopPresence() {
  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null;
  }
}
